import * as types from "./actionTypes";
import * as appointmentApi from "../../_api/appointmentApi";
import { beginApiCall, apiCallError } from "./apiStatusActions";

export function resetAppointmentsSuccess() {
  return { type: types.RESET_APPOINTMENTS_SUCCESS };
}

export function resetLocationsSuccess() {
  return { type: types.RESET_LOCATIONS_SUCCESS };
}

export function resetAvailableDatesSuccess() {
  return { type: types.RESET_AVAILABLE_DATES_SUCCESS };
}

export function resetAvailableHoursSuccess() {
  return { type: types.RESET_AVAILABLE_HOURS_SUCCESS };
}

export function createAppointmentSuccess(appointments) {
  return { type: types.CREATE_APPOINTMENT_SUCCESS, appointments };
}

export function loadLocationsSuccess(locations) {
  return { type: types.LOAD_LOCATIONS_SUCCESS, locations };
}

export function loadAvailableDatesSuccess(availableDates) {
  return { type: types.LOAD_AVAILABLE_DATES_SUCCESS, availableDates };
}

export function loadAvailableHoursSuccess(availableHours) {
  return { type: types.LOAD_AVAILABLE_HOURS_SUCCESS, availableHours };
}

export function createAppointment(params) {
  return function (dispatch) {
    dispatch(beginApiCall());
    return appointmentApi
      .createAppointment(params)
      .then((apptObj) => {
        dispatch(createAppointmentSuccess(apptObj));
        return apptObj;
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

export function sendAppointmentConfirmation(params) {
  return function (dispatch) {
    dispatch(beginApiCall());
    return appointmentApi
      .confirmationEmail(params)
      .then(() => {
        return "Sent";
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

export function loadAppointments(clientId) {
  return function (dispatch) {
    dispatch(beginApiCall());
    return appointmentApi
      .getAppointments(clientId)
      .then((appointments) => {
        return appointments;
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

export function resetAppointments() {
  return function (dispatch) {
    dispatch(resetAppointmentsSuccess());
  };
}

export function loadLocationsWithinRadius(
  lat,
  lng,
  radius,
  dType,
  test,
  brandIdentifier,
  partnerList,
  clientId,
) {
  return function (dispatch) {
    dispatch(beginApiCall());
    return appointmentApi
      .getLocationsWithinRadius(
        lat,
        lng,
        radius,
        dType,
        test,
        brandIdentifier,
        clientId,
      )
      .then((locations) => {
        if (!partnerList) {
          dispatch(loadLocationsSuccess(locations));
        }
        if (locations.length === 0) {
          dispatch(loadLocationsSuccess([{ CurrentState: "None" }]));
        } else {
          let updatedLocations = [];
          // Use partner List to see if we have a partner in our return
          if (partnerList[0] === "0") {
            updatedLocations = locations.map((x) => ({
              ...x,
              partner: false,
            }));
          } else {
            // Split the locations into a partner array & nonpartner array
            // If there is a partner(s), place these locations at the top of the list
            let partnerArray = [];
            let nonpartnerArray = [];
            partnerList.forEach((e) => {
              let thisVal = locations.filter((x) => e.includes(x.locationID));
              if (thisVal.length !== 0) {
                partnerArray.push(thisVal[0]);
              }
            });
            partnerArray = partnerArray.map((x) => ({
              ...x,
              partner: true,
            }));
            nonpartnerArray = locations.map((x) => ({
              ...x,
              partner: false,
            }));

            let ids = new Set(partnerArray.map((x) => x.locationID));
            updatedLocations = [
              ...partnerArray,
              ...nonpartnerArray.filter((x) => !ids.has(x.locationID)),
            ];
          }
          dispatch(loadLocationsSuccess(updatedLocations));
        }
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

export function resetLocations() {
  return function (dispatch) {
    dispatch(resetLocationsSuccess());
  };
}

export function loadAvailableDates(
  ClientId,
  VehicleId,
  Locationid,
  deviceType,
  appointmenttype,
  appointmentdate,
  sameDay,
) {
  return function (dispatch) {
    dispatch(beginApiCall());
    return appointmentApi
      .getAvailableDates(
        ClientId,
        VehicleId,
        Locationid,
        deviceType,
        appointmenttype,
        appointmentdate,
        sameDay,
      )
      .then((availableDates) => {
        if (sameDay === true) {
          if (availableDates.length === 0) {
            dispatch(loadAvailableDatesSuccess([{ CurrentState: "None" }]));
          } else {
            dispatch(loadAvailableDatesSuccess(availableDates));
          }
        } else {
          //Ensure the date is great than tomorrow
          let startDate = new Date();
          startDate.setDate(startDate.getDate() + 1);

          const filterReturnedDates = (arr) =>
            arr.filter(({ date }) => new Date(date) > startDate);
          let filteredDates = filterReturnedDates(availableDates);

          if (filteredDates.length === 0) {
            dispatch(loadAvailableDatesSuccess([{ CurrentState: "None" }]));
          } else {
            dispatch(loadAvailableDatesSuccess(filteredDates));
          }
        }
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

export function resetAvailableDates() {
  return function (dispatch) {
    dispatch(resetAvailableDatesSuccess());
  };
}

export function loadAvailableHours(
  ClientId,
  Locationid,
  devicetype,
  appointmenttype,
  appointmentdate,
) {
  return function (dispatch) {
    dispatch(beginApiCall());
    return appointmentApi
      .getAvailableTimes(
        ClientId,
        Locationid,
        devicetype,
        appointmenttype,
        appointmentdate,
      )
      .then((availableHours) => {
        if (availableHours.length === 0) {
          dispatch(loadAvailableHoursSuccess([{ CurrentState: "None" }]));
        } else {
          const sortedHours = availableHours.sort(
            (a, b) => new Date(a.date) - new Date(b.date),
          );
          dispatch(loadAvailableHoursSuccess(sortedHours));
        }
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

export function resetAvailableHours() {
  return function (dispatch) {
    dispatch(resetAvailableHoursSuccess());
  };
}


export function loadLocation(locationId)
{
    return function (dispatch) {
    dispatch(beginApiCall());
    return appointmentApi
      .getLocation(locationId)
      .then((location) => {
        return location;
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}